import { gql } from "@apollo/client";

export const DELETE_BLOG = gql`
  mutation removeBlog($id: Int!) {
    removeBlog(id: $id) {
      id
    }
  }
`;